import React from "react";

// Shared status-badge tones — used everywhere a lead stage, request status,
// transaction status, or verified/unverified state needs a colored pill
// instead of the plain inline-colored text every screen used to hand-roll.
export const statusTones = {
  neutral: "bg-gray-100 text-gray-600",
  info: "bg-blue-50 text-blue-700",
  success: "bg-emerald-50 text-emerald-700",
  warning: "bg-amber-50 text-amber-700",
  danger: "bg-red-50 text-red-700",
};

/**
 * @param {string} label - text to display
 * @param {keyof statusTones} tone - defaults to 'neutral'
 */
export default function StatusPill({ label, tone = "neutral" }) {
  return (
    <span className={`inline-flex items-center text-xs font-medium px-2.5 py-1 rounded-full whitespace-nowrap ${statusTones[tone] || statusTones.neutral}`}>
      {label}
    </span>
  );
}
